<template>
  <d-modal
    :active="isActive"
    :width="600"
    @close="handleClose"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="p-6">
      <!-- Header -->
      <div class="mb-6">
        <h3 class="text-2xl font-bold">
          Impersonate User
        </h3>
        <p>
          Enter the email address of the user you want to impersonate
        </p>
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="alert alert-error mb-4">
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Form -->
      <form @submit.prevent="impersonate" class="space-y-4">
        <!-- Email Field -->
        <d-field label="User's Email Address *">
          <d-input 
            v-model="emailAddress" 
            type="email"
            :required="true"
            placeholder="Enter email address"
            @keydown.enter="impersonate"
          />
        </d-field>

        <!-- Loading State -->
        <div v-if="loading" class="flex justify-center py-4">
          <span class="loading loading-spinner loading-md"></span>
        </div>

        <!-- Form Actions -->
        <div class="flex justify-end gap-3 pt-4">
          <d-btn 
            type="button"
            color="secondary"
            @click="handleClose"
          >
            Cancel
          </d-btn>
          <d-btn 
            type="submit"
            color="primary"
            :disabled="!emailAddress || loading"
          >
            Impersonate
          </d-btn>
        </div>
      </form>
    </div>
  </d-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ImpersonateModal',
  
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      emailAddress: '',
      errorMessage: '',
      loading: false
    }
  },

  computed: {
    isActive() {
      return this.active;
    }
  },

  watch: {
    active(newVal) {
      if (newVal) {
        this.resetForm();
      }
    }
  },

  methods: {
    resetForm() {
      this.emailAddress = '';
      this.errorMessage = '';
      this.loading = false;
    },

    async impersonate() {
      if (!this.emailAddress) return;
      
      this.loading = true;
      this.errorMessage = '';
      
      try {
        const response = await fetch('/Account/Impersonate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.emailAddress }),
        })
        
        console.log('Response:', response);
        
        if (response.ok) {
          window.location.href = '/';
        } else {
          const data = await response.json();
          if (data.error) {
            this.errorMessage = data.error;
          } else {
            this.errorMessage = 'Failed to impersonate user';
          }
        }
      } catch (error) {
        console.error('Error:', error);
        this.errorMessage = 'An error occurred while trying to impersonate the user';
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.$emit('close');
    }
  }
})
</script>


<style scoped>

</style>